import {IImage} from '../../../service/contentServer';
import * as _ from 'lodash';
import * as React from 'react';
import {ReactNode} from 'react';
import LazyLoad from 'react-lazyload';

export function getImgWithIdAndImageData(id, images: IImage[], isLazy) {
  if (id) {
    const image = _.find(images, (o) => o.id === id) as IImage;
    if (image) {
      if (isLazy) {

        return <LazyLoad key={`LazyLoad-${id}`} height={50} offset={200} placeholder={placeHolder()}>
          <img className="res-image" src={image.optimalUrl || image.url}/>
        </LazyLoad>;
      } else {
        return <img className="res-image" key={`img-${id}`} src={image.optimalUrl || image.url}/>;
      }
    } else {
      return null;
    }
  }
}

function placeHolder(): ReactNode {
  return <span className="placeholder">
          </span>;
}
